import { PickerButton } from "./PickerButton";
import { PickerButtonTrigger } from "./PickerButtonTrigger";
import { PickerCellInputTrigger } from "./PickerCellInputTrigger";
import { PickerCellContent } from "./PickerCellContent";
import { PickerCellTrigger } from "./PickerCellTrigger";
import { PickerFlyout } from "./PickerFlyout";
import { PickerInputTrigger } from "./PickerInputTrigger";
import { PickerItem } from "./PickerItem";
import { PickerItemAction } from "./PickerItemAction";
import { PickerLoadMore } from "./PickerLoadMore";
import { PickerAccountItem, PickerToggleItem } from "./PickerItemPresets";
import {
    PickerEmpty,
    PickerError,
    PickerFooter,
    PickerLoading,
    PickerSearch,
} from "./PickerParts";
import { PickerList, PickerPopup } from "./PickerPopup";
import {
    PickerSection,
    PickerSectionTitle,
    PickerSeparator,
} from "./PickerSection";
import { PickerSelect } from "./PickerSelect";
import { PickerTrigger } from "./PickerTrigger";

export {
    pickerTreeRowPlacements,
    type PickerTreeRowPlacement,
} from "./PickerTreePlacements";
export { pruneItemsByQuery } from "./PickerTreeQuery";
export type { PickerAttachedTriggerProps } from "./PickerAttachedTrigger";
export type { PickerButtonTriggerProps } from "./PickerButtonTrigger";
export type { PickerCellInputTriggerProps } from "./PickerCellInputTrigger";
export type {
    PickerCellContentProps,
    PickerCellTriggerProps,
} from "./PickerCellTrigger";
export type { PickerItemActionProps } from "./PickerItemAction";
export type { PickerFooterProps, PickerSearchProps } from "./PickerParts";
export type { PickerListProps } from "./PickerPopup";
export type {
    PickerSectionProps,
    PickerSectionTitleProps,
} from "./PickerSection";
export type {
    PickerAttachedTriggerRootProps,
    PickerButtonTriggerOptions,
    PickerButtonTriggerRootProps,
    PickerCellEditor,
    PickerCellTriggerButtonProps,
    PickerChevron,
    PickerClassNames,
    PickerCustomValueProps,
    PickerCustomValueSelectProps,
    PickerEmptyBehavior,
    PickerFlyoutAutoOpen,
    PickerFlyoutOptions,
    PickerFlyoutProps,
    PickerFlyoutQueryScope,
    PickerForcedState,
    PickerInlineRootProps,
    PickerInputTriggerOptions,
    PickerInputTriggerProps,
    PickerInputTriggerRootProps,
    PickerInputTriggerSize,
    PickerItemData,
    PickerItemProps,
    PickerItemValue,
    PickerListRootProps,
    PickerNested,
    PickerParentSelection,
    PickerPopupProps,
    PickerSectionData,
    PickerSectionSelectAll,
    PickerSelectionSummary,
    PickerSelectListProps,
    PickerSelectProps,
    PickerStatus,
    PickerTreePosition,
    PickerTriggerButtonProps,
    PickerTriggerElement,
    PickerTriggerPreset,
    PickerValue,
    PickerValueProps,
} from "./Picker.types";

/**
 * The Picker family: one popup-chooser kit on Base UI, styled from the Figma
 * `_Select/*` anatomy. One root, `Select` (every list chooser, by `trigger`);
 * every other key is a part it composes. A composed root's labelled Button
 * trigger is `ButtonTrigger` (the same one the data-driven root renders from
 * its `trigger` prop); `Trigger` with `render` is the bare escape hatch.
 */
export const Picker = {
    Select: PickerSelect,
    Trigger: PickerTrigger,
    ButtonTrigger: PickerButtonTrigger,
    Button: PickerButton,
    InputTrigger: PickerInputTrigger,
    CellTrigger: PickerCellTrigger,
    CellInputTrigger: PickerCellInputTrigger,
    CellContent: PickerCellContent,
    Popup: PickerPopup,
    List: PickerList,
    Item: PickerItem,
    ItemAction: PickerItemAction,
    Flyout: PickerFlyout,
    AccountItem: PickerAccountItem,
    ToggleItem: PickerToggleItem,
    Section: PickerSection,
    SectionTitle: PickerSectionTitle,
    Separator: PickerSeparator,
    Search: PickerSearch,
    Footer: PickerFooter,
    Empty: PickerEmpty,
    Loading: PickerLoading,
    Error: PickerError,
    LoadMore: PickerLoadMore,
};
